import { callCSSFn, CSS, styled, StyleProps } from "../../styles"
import { boxCss } from "../../Box"

export interface StyledLinkProps {
  variant: `heading` | `subheading`
  state: `active` | `inactive`
}

type Props = StyledLinkProps & StyleProps

const getBeforeCSS = (props: Props): CSS | undefined => {
  if (props.state === `inactive`) return undefined
  return {
    content: `""`,
    position: `absolute`,
    width: `3px`,
    backgroundColor: props.theme.palette.brand,
    height: `100%`,
    left: 0,
    top: 0,
  }
}

const sharedLinkCSS = (props: Props): CSS => ({
  ...boxCss,
  ...props.theme.fonts.body,
  ...callCSSFn(props),
  alignItems: `center`,
  backgroundColor: props.state === `active` ? props.theme.palette.coal.light : `unset`,
  "&::before": getBeforeCSS(props),
  borderBottomRightRadius: props.theme.borderRadius.sm,
  borderTopRightRadius: props.theme.borderRadius.sm,
  color: props.theme.palette.white,
  cursor: `pointer`,
  display: `flex`,
  height: props.variant === `heading` ? `52px` : `40px`,
  paddingRight: props.theme.spacing(6),
  position: `relative`,
  textDecoration: `none`,
  textTransform: `none`,
  width: `100%`,
  borderBottom: `1px solid ${props.theme.palette.coal.light}`,
  "&:nth-of-type(1)": {
    borderTop: `1px solid ${props.theme.palette.coal.light}`,
  },
  "&:hover": {
    backgroundColor: props.theme.palette.coal.light,
  },
})

export const StyledLink = styled.div<StyledLinkProps>((props: Props) => ({
  paddingLeft:
    props.variant === `heading`
      ? props.theme.spacing(6)
      : `calc(${props.theme.spacing(6)} + ${props.theme.spacing(4)})`,
  ...sharedLinkCSS(props),
}))

export const StyledGroupWithLink = styled.div<StyledLinkProps>((props: Props) => ({
  ...sharedLinkCSS(props),
  paddingLeft: props.theme.spacing(6),
  justifyContent: `space-between`,
  height: `52px`,
}))

export const linkCSS = (props: StyleProps) => ({
  width: `100%`,
  padding: props.theme.spacing(5),
  paddingLeft: props.theme.spacing(6),
})
